<template>
    <div class="publicizeList flex-sub flex flex-direction">
        <div class="list-box flex-sub flex flex-direction">
            <div class="title">{{ detail.title }}</div>

            <div class="flex justify-center align-center desc">
                <div v-if="detail.author" class="time">
<!--                    <i class="iconfont icon-zuozhe"></i>-->
                    作者：{{ detail.publish_time }}
                </div>
                <div class="time">
<!--                    <i class="iconfont icon-shijian6"></i>-->
                    时间：{{ detail.publish_time }}
                </div>
                <div v-if="detail.resource" class="time">
<!--                    <i class="iconfont icon-laiyuan1"></i>-->
                    来源：{{ detail.resource }}
                </div>
            </div>

            <!--          <div class="time">-->
            <!--            <i class="iconfont icon-shijian5"></i>-->
            <!--            时间：{{detail.publish_time}}-->
            <!--          </div>-->

            <div class="content" v-html="detail.content"></div>
        </div>
    </div>
</template>
<script>
import {masses_article_detail} from "@/api";
import {loaded, loading} from "@/utils/utils";

export default {
    name: "policyList",
    data() {
        return {
            id: '',
            type: '',
            bannerTex: '',
            bannerStr: '',
            detail: {
                title: '',
                resource: '',
                author: '',
                publish_time: '',
                content: ''
            }
        }
    },
    components: {},
    created() {
        this.id = this.$route.query.id
        this.type = this.$route.query.type
        this.bannerFun()
        this.init()
    },
    methods: {
        async init() {
            loading()
            let _data = await masses_article_detail(this.id);
            loaded()
            if (_data.status == 200) {
                this.detail = _data.data
            }
        },
        bannerFun() {
            switch (Number(this.type)) {
                case 1:
                    document.title = '政策法规'
                    break;
                case 3:
                    document.title = '宣传信息'
                    break;
                case 5:
                    document.title = '科技专栏'
                    break;
                default:
                    document.title = '详情'
                    break;
            }
        },
    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
::v-deep{
    .content {
        width: 100%;
        font-size: 3.7vw;
        line-height: 6.5vw;
        color: #333640;
        margin-top: 3.3vw;

        img,video {
            max-width: 100%;
            display: block;
            margin: 2vw auto;
        }
    }
}
.publicizeList {
    background: #ebf4ff;
    padding: 2.9vw 3.5vw;
    .list-box {
        width: 100%;
        background-color: #ffffff;
        box-shadow: 0.7vw 0.5vw 2.1vw 0vw
        rgba(0, 46, 108, 0.19);
        border-radius: 1.3vw;
        border: solid 0.3vw #ffffff;
        padding: 2.9vw 3.5vw;



        .title {
            width: 100%;
            font-size: 4.3vw;
            font-weight: 600;
            line-height: 5.9vw;
            color: #141c24;
        }

        .desc {
            width: 100%;
            padding-bottom: 3.9vw;
            border-bottom: 1px solid #e9e9e9;
            margin-top: 30px;

            .time {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 2.9vw;
                color: #000000;
                padding: 0 3vw;

                i {
                    font-size: 2.9vw;
                    color: #000000;
                    margin-right: 1vw;
                }
            }
        }

    }
}
</style>


